import React from 'react';
const stats = [{
  value: '$2.3B+',
  label: 'Tracked annually',
  icon: '💰'
}, {
  value: '100K+',
  label: 'Active users',
  icon: '👥'
}, {
  value: '4.8★',
  label: 'App store rating',
  icon: '⭐'
}, {
  value: '23%',
  label: 'Avg. savings increase',
  icon: '📈'
}];
export function StatsSection() {
  return <section className="bg-primary-500 py-16" data-id="element-931">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-932">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-933">
          {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-934">
              <div className="text-3xl mb-2" data-id="element-935">{stat.icon}</div>
              <p className="text-4xl font-black text-white mb-1" data-id="element-936">
                {stat.value}
              </p>
              <p className="text-primary-200 text-sm" data-id="element-937">{stat.label}</p>
            </div>)}
        </div>
      </div>
    </section>;
}